export default __webpack_public_path__ + "static/img_1_2-f17747abe4ef03d1bac59b3b2f87cb13.webp";